var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7578 8.40687V19.7669C19.7578 21.2169 18.7178 21.8269 17.4478 21.1269L13.5178 18.9369C13.0978 18.7069 12.4178 18.7069 11.9978 18.9369L8.06781 21.1269C6.79781 21.8269 5.75781 21.2169 5.75781 19.7669V8.40687C5.75781 6.69687 7.1578 5.29688 8.8678 5.29688H16.6478C18.3578 5.29688 19.7578 6.69687 19.7578 8.40687Z",
    fill: "#FD9C00",
    stroke: "#FD9C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFilled);
export default __webpack_public_path__ + "static/media/bookmark-filled.d5cae2240421228a6c1ae83c0e675b76.svg";
export { ForwardRef as ReactComponent };